import React, { useEffect } from 'react'
import PropTypes from 'prop-types'
import { compose } from 'recompose'
import { connect } from 'react-redux'
import { selectors as NotesSelectors } from 'data/notes'
import { selectors as ChannelsSelectors } from 'data/channels'
import { selectors as UserPreferencesSelectors } from 'data/userPreferences'
import { selectors as OrganizationSelectors } from 'data/organizations'
import { selectors as UISelectors } from 'data/ui'
import { providesRecentHistoryEntries } from './dataSync'
import useQuickSwitchResults from './useQuickSwitchResults'
import Row, { Loading } from './Row'

function QuickSwitchSearchResults({
  algoliaClient,
  query,
  organization,
  onEntrySelected,
  onEntries,
  highlightedEntryIndex,
  allNotes,
  lastVisitedNotesIds,
  allChannels,
  lastVisitedChannelsIds,
  lastSearchedTerms,
  activeNoteId,
  renderEmptyPlaceholder,
  setHighlightedEntryIndex,
}) {
  const [entries, isLoading] = useQuickSwitchResults({
    query,
    algoliaClient,
    allNotes,
    lastVisitedNotesIds,
    allChannels,
    lastVisitedChannelsIds,
    lastSearchedTerms,
    organization,
    activeNoteId,
  })

  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => onEntries(entries), [entries])
  if (isLoading) {
    return (
      <React.Fragment>
        <Loading />
        <Loading />
        <Loading />
      </React.Fragment>
    )
  }

  if (!entries.length) {
    return renderEmptyPlaceholder()
  }
  return (
    <React.Fragment>
      {entries.map((entry, index) => (
        <Row
          key={entry.key}
          entry={entry}
          onClick={() => onEntrySelected(entry)}
          isHighlighted={index === highlightedEntryIndex}
          onMouseMove={() => setHighlightedEntryIndex(index)}
        />
      ))}
    </React.Fragment>
  )
}

QuickSwitchSearchResults.propTypes = {
  query: PropTypes.string.isRequired,
  algoliaClient: PropTypes.object.isRequired,
  onEntrySelected: PropTypes.func.isRequired,
  onEntries: PropTypes.func.isRequired,
  highlightedEntryIndex: PropTypes.number.isRequired,
  setHighlightedEntryIndex: PropTypes.func.isRequired,
  lastSearchedTerms: PropTypes.any.isRequired,
  activeNoteId: PropTypes.string,
}

export default compose(
  providesRecentHistoryEntries,
  connect(state => {
    const allChannels = ChannelsSelectors.getChannels(state)
    const allNotes = NotesSelectors.getAllNotes(state)
    const organization = OrganizationSelectors.getOrganization(state)
    const lastVisitedNotesIds = UserPreferencesSelectors.getLastVisitedNoteIds(
      state
    )
    const lastVisitedChannelsIds = UserPreferencesSelectors.getLastVisitedChannelIds(
      state
    )
    const lastSearchedTerms = UserPreferencesSelectors.getLastSearchedTerms(
      state
    )
    const activeNoteId = UISelectors.getActiveNoteId(state)
    return {
      organization,
      allNotes,
      lastVisitedNotesIds,
      allChannels,
      lastVisitedChannelsIds,
      lastSearchedTerms,
      activeNoteId,
    }
  })
)(QuickSwitchSearchResults)
